import React from 'react';
import styled from 'styled-components';
import Text from '@ingka/text';
import variables from '@ingka/variables/design-tokens';
import { SparePartCount } from '../interfaces/Item';
import { Item } from './Item';
import useTranslation from '../hooks/useTranslation';

const Wrapper = styled.div`
  margin: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  ${`@media (min-width: ${variables.breakpointM}) {
    width: fit-content;
    margin-left: auto;
  }`}
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const ItemsTitle = styled(Text)`
  &&& {
    display: block;
    width: 100%;
    max-width: 100%;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
  margin: 0;
  margin-top: 1.5rem;
  padding: 0;
  list-style: none;
`;

interface OrderItemsSummaryProps {
  items: SparePartCount[];
}

const OrderItemsSummary: React.FC<OrderItemsSummaryProps> = ({ items }) => {
  const { t } = useTranslation();

  if (!items.length) return null;

  return (
    <Wrapper>
      <ItemsTitle tagName="h3" textStyle="Heading.S">
        {t('customerInformation.items.title')}
      </ItemsTitle>
      <List as="ul">
        {items
          .filter(({ item }) => item)
          .map(({ item, quantity }) => (
            <Item
              key={item.id}
              item={item}
              showImageDot={true}
              enableOptions={false}
            >
              <Text tagName="p" textStyle="Body.M">
                {t('customerInformation.items.quantity', { quantity })}
              </Text>
            </Item>
          ))}
      </List>
    </Wrapper>
  );
};

export default OrderItemsSummary;
